// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Action

import { customerActions } from "stores/customer/customerActions";
import { commonActions } from "stores/common/commonActions";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";

const mapStateToProps = (state) => {
    return {
        // onboarding
        currentStage: state.sentimentTracker.sentimentTrackerOnboarding.currentStage,
        duplicateStages: state.sentimentTracker.sentimentTrackerOnboarding.duplicateStages,
        sentimentTrackerOnboardingSteps: state.sentimentTracker.sentimentTrackerOnboarding.sentimentTrackerOnboardingSteps,
        isPaymentCompleted: state.sentimentTracker.sentimentTrackerOnboarding.isPaymentCompleted,


        // user
        isEmailVerified: state.customer.loginProfile.isEmailVerified,
        emailId: state.customer.loginProfile.email,
        name: state.customer.loginProfile.name,

        // other's
        isOnboardingDataFetched: state.onboarding.isInitialFetched,
        isOnboardingDataLoading: state.onboarding.loading.onboardingData,
        isPortfolioOnboardingCompleted: state.onboarding.isOnboardingCompleted,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getOnboardingDataAction: sentimentTrackerOnboardingActions.getOnboardingData,
            updateEmailAction: customerActions.updateEmail,
            setToast: commonActions.setToast,
            logoutAction: customerActions.logout,
        },
        dispatch
    );

const SentimentTrackerOnboardingLayoutStore = (Container) => {
    return connect(mapStateToProps, mapDispatchToProps)(Container);
};

export default SentimentTrackerOnboardingLayoutStore;
